export const REMEMBER_ME_HEADERS = {
  'X-Remember-Me': 'true',
};

export function buildAuthHeaders({ rememberMe, realIp } = {}) {
  return {
    ...(rememberMe === undefined ? {} : { 'X-Remember-Me': String(Boolean(rememberMe)) }),
    ...(realIp ? { 'X-Real-IP': realIp } : {}),
  };
}
